// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federwerkstoff/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federwerkstoffDE: PageEntry = {
  id: "post.federwerkstoff",
  locale: "de",
  slug: "federwerkstoff",
  seo: {
    title: "Glossar: Federwerkstoff einfach erklärt | Dietz GmbH",
    description: "Federwerkstoff bezieht sich auf das Material, aus dem eine Feder hergestellt ist. Verschiedene Werkstoffe, wie Stahl, Edelstahl, Titan oder Kunststoffe, können für Federn verwendet",
  },
  type: "post",
  h1: "Glossar: Federwerkstoff einfach erklärt",
  intro: "Federwerkstoff bezieht sich auf das Material, aus dem eine Feder hergestellt ist. Verschiedene Werkstoffe, wie Stahl, Edelstahl, Titan oder Kunststoffe, können für Federn verwendet werden. Die Wahl des richtigen Federwerkstoffs hängt von den spezifischen Anforderungen der Anwendung ab, einschließlich Festigkeit, Elastizität, Korrosionsbeständigkeit und Temperaturbeständigkeit. Ein sorgfältig ausgewählter Federwerkstoff ist entscheidend, um sicherzustellen, dass die Feder den Anforderungen ihrer Umgebung standhalten und ihre Funktion über einen langen Zeitraum aufrechterhalten kann.",
  blocks: [

  ],
};
